import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const TruckFleet: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m210 480.67h30v139.33h-30z' />
    <path d='m510 780c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m120 780c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m630 735h-75v-30h45v-225c0-24.81-20.19-45-45-45h-315v60h-146.3l-57.76 101c-3.88 6.79-5.94 14.52-5.94 22.34v86.66h45v30h-75v-116.66c0-13.04 3.42-25.91 9.9-37.23l66.4-116.11h133.7v-60h345c41.36 0 75 33.65 75 75z' />
    <path d='m160 705h310v30h-310z' />
    <path d='m25 585h190v30h-190z' />
    <path d='m210 675v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m360 75.67h30v139.33h-30z' />
    <path d='m660 375c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m270 375c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m780 330h-75v-30h45v-225c0-24.81-20.19-45-45-45h-315v60h-146.3l-57.76 101c-3.88 6.79-5.94 14.52-5.94 22.34v86.66h45v30h-75v-116.66c0-13.04 3.42-25.91 9.9-37.23l66.4-116.11h133.7v-60h345c41.36 0 75 33.65 75 75z' />
    <path d='m310 300h310v30h-310z' />
    <path d='m175 180h190v30h-190z' />
    <path d='m360 270v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
  </IconBase>
));

TruckFleet.displayName = 'TruckFleet';

export default TruckFleet;
